/**
 * Carrinho: lembrete de aro + toggle de customizações.
 */
(function () {
  var CHAVE_GUIA = 'lora_guia_carrinho_ok';

  function temCustomizacaoNoCarrinho() {
    return !!document.querySelector('[data-lora-cart-props], .cart-items__properties');
  }

  function alternarCustomizacoes(btn) {
    var wrap = btn.closest('.cart-items__details, .cart-items__table-row, td, .cart-items__product-info') || btn.parentElement;
    var props =
      (wrap && wrap.querySelector('[data-lora-cart-props], .cart-items__properties')) ||
      btn.nextElementSibling;
    if (!props || !props.classList.contains('cart-items__properties')) {
      props = btn.parentElement && btn.parentElement.querySelector('[data-lora-cart-props], .cart-items__properties');
    }
    if (!props) return;

    var aberto = btn.getAttribute('aria-expanded') !== 'false';
    btn.setAttribute('aria-expanded', aberto ? 'false' : 'true');
    btn.textContent = aberto ? 'Ver customizações' : 'Ocultar customizações';
    props.classList.toggle('is-oculto', aberto);
    props.hidden = aberto;
  }

  function fecharGuia(dialog) {
    try {
      sessionStorage.setItem(CHAVE_GUIA, '1');
    } catch (e) {
      /* ignore */
    }
    if (dialog.open) dialog.close();
    dialog.remove();
  }

  function mostrarGuiaSePreciso() {
    try {
      if (sessionStorage.getItem(CHAVE_GUIA) === '1') return;
    } catch (e) {
      /* ignore */
    }
    if (!temCustomizacaoNoCarrinho()) return;
    if (document.querySelector('[data-lora-guia-carrinho]')) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'lora-guia-carrinho';
    dialog.setAttribute('data-lora-guia-carrinho', '');
    dialog.setAttribute('aria-labelledby', 'lora-guia-titulo');
    dialog.innerHTML =
      '<div class="lora-guia-carrinho__card">' +
      '<p class="lora-guia-carrinho__eyebrow">Antes de finalizar</p>' +
      '<h2 id="lora-guia-titulo" class="lora-guia-carrinho__titulo">Confira o aro</h2>' +
      '<p class="lora-guia-carrinho__texto">Meça o dedo com uma fita ou com um anel que sirva bem. Se ainda tiver dúvida, volte na página do produto e abra o guia de tamanhos.</p>' +
      '<button type="button" class="lora-guia-carrinho__ok" data-lora-guia-ok>Confirmei meu aro</button>' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.querySelector('[data-lora-guia-ok]').addEventListener('click', function () {
      fecharGuia(dialog);
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      fecharGuia(dialog);
    });

    // showModal() entra no top layer do browser — acima da sacola (também dialog modal)
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lora-toggle-custom]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      alternarCustomizacoes(btn);
      return;
    }

    if (
      e.target.closest(
        '.header-actions__cart-icon, cart-icon-component, [href$="/cart"], button[aria-controls="cart-drawer"]'
      )
    ) {
      window.setTimeout(mostrarGuiaSePreciso, 400);
    }
  });
})();
